import { symbols_hex } from '@shared/constants';

export function DotSeperator() {
  return <span className="text-gray-800">{symbols_hex.white_dot}</span>;
}
